// Pre-auths — pure helpers. One date helper.
export const PA_USER = { name: 'Ava Thompson', org: 'Lone Star Billing' } as const;
/** The practice owner, who alone turns pre-auth autopilot on (D300). */
export const OWNER_NAME = 'Dr. Emily Carter';
export const TODAY_ISO = '2026-10-15';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function parse(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

export function formatShort(iso: string): string {
  const d = parse(iso);
  if (!d) return iso;
  return `${MONTHS[d.getUTCMonth()] ?? ''} ${String(d.getUTCDate())}`;
}

/** Whole days from today to an ISO date. */
export function daysUntil(iso: string, fromIso: string = TODAY_ISO): number {
  const a = parse(fromIso);
  const b = parse(iso);
  if (!a || !b) return 0;
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

export function money(n: number): string {
  return `$${Math.round(n).toLocaleString('en-US')}`;
}

export function clockNow(): string {
  const d = new Date();
  let h = d.getHours();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${String(h)}:${String(d.getMinutes()).padStart(2, '0')} ${ampm}`;
}
